import {Binary} from '@angular/compiler';

/* User and Login */

export interface LoginUser {
  Id: string;
  access_token: string;
  '.expires': string;
}

export class User {
  UserId: number;
  Email: string;
  LoginName: string;
  Password?: string;
  FirstName: string;
  LastName: string;
  Phone: string;
  PrimaryAddressAid: string;
  HomeDeliveryPartnerAddressAid: string;
  RightStatus: number;
  Companies: string;
  Addresses: string;
  CreatorUserId: number;
  Language: string;
  FirstLogin: boolean;
  TermsAndConditionRead: boolean;
  MultiPartnerUser: boolean;
  ConfirmationMail: boolean;
  ConfirmationMailAsked: boolean;
  SaturdayDelivery: boolean;
  WnExternal: boolean;
  CreationDate: Date;
  LastUpdate: Date;
  Rights: Right[];
  Modules: Module[];
  WheelnewsAddress: WheelnewsAddress;
  ProcessIds: string;
  OrderSource: string;
}

export class Right {
  RightId: number;
  Description: string;
}

export class Module {
  ModuleId: number;
  ModuleName: string;
  ModuleDesc: string;
  ModuleButtonText: string;
  ModuleImage: string;
  ModuleLogo: string;
  ForwardLink: string;
  IsNew: boolean;
  Counter?: number;
}

export class UserModule {
  Id: number;
  UserId: number;
  ModuleId: number;
}

export class UserRight {
  Id: number;
  UserId: number;
  RightId: number;
}

export class WheelnewsAddress {
  Id: number;
  UserId: number;
  Company: string;
  Additive: string;
  StreetAndNumber: string;
  Zip: string;
  City: string;
}

/* General / Menu */

export class Card {
  Title: string;
  Desc: string;
  Action: string;
  ForwardLink: string;
}

export class News {
  Id: string;
  Title: string;
  Summary: string;
  Updated: Date;
  Published: Date;
  Content: string;
}

export class ContactMessage {
  Title: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Phone: string;
  Company: string;
  Street: string;
  Zip: string;
  City: string;
  Message: string;
  Type: string;
  Transport: boolean;
  DamageReport: boolean;
  WheelNews: boolean;
  Fotobox: boolean;
}

export class Mail {
  Id: number;
  Email: string;
  MailType: string;
  Module: string;
}

export class ApiToken {
  Id: number;
  Value: string;
  Company: string;
}

export class Response<T> {
  Ok: boolean;
  Obj: T;
  Msg: string;
  Ex: string;
}

/* VehicleState */

export class VehicleState {
  OrderId: string;
  ClientId: string;
  ClientReference1: string;
  ClientReference2: string;
  ClientReference3: string;
  ModelId: string;
  ModelName: string;
  SenderId: string;
  SenderName: string;
  SenderCity: string;
  SenderDate: string;
  RecipientId: string;
  RecipientName: string;
  RecipientCity: string;
  RecipientDate: string;
  Active: boolean;
  Status: number;
  DeliveryStatus: string;
  DeliveryAppointment: string;
}

/* Orders */

export class Order {
  Client: Client;
  Sender: Sender;
  Recipient: Recipient;
  VehicleList: Vehicle[];
  FreightPayerSelection: number;
  FreightPayerAid: string;
  FreightPayerFid: string;
  UserId: number;
  User: string;
  Phone: string;
  Email: string;
  Message: string;
  Language: string;
  ProductGroup: number;
  DeliveryOption: number;
  DeliveryOptionText: string;
  ConfirmationMail: boolean;
}

export class WheelNewsOrder {
  Id: number;
  OrderDate: Date;
  Client: Client;
  Sender: Sender;
  Recipient: Recipient;
  RimsetList: Rimset[];
  FreightPayerSelection: number;
  FreightPayerAid: string;
  FreightPayerFid: string;
  User: string;
  UserId: number;
  Phone: string;
  Email: string;
  Message: string;
  Language: string;
  DeliveryOption: number;
  DeliveryOptionText: string;
  WillBeBroughtByCustomer: boolean;
  WillBePickedUpByCustomer: boolean;
  WheelnewsSpecial: string;
}

export class Vehicle {
  ModelName: string;
  ChassisNumber: string;
  CommissionNumber: string;
  License: string;
  Color: string;
  Comment: string;
  SpecialSelects: SpecialSelect[];
  SpecialTextActive: boolean;
  SpecialComment: string;
  Files: Document[];
}

export class Model {
  Id: number;
  UnitId: string;
  UnitRemark: string;
}

export class Rimset {
  CommissionNumber: string;
  SparePartNumber: string;
  OrderTypes: SpecialSelect[];
  OrderTypesString: string;
  Repaint: SpecialSelect;
  DamageCommentTextActive: boolean;
  RepaintCommentTextActive: boolean;
  DamageComment: string;
  RepaintComment: string;
  RimAmount: number;
  Comment: string;
  Files: Document[];
}

export class Document {
  FileName: string;
  Base64String: string | ArrayBuffer;
}

export class SpecialSelect {
  Key: number;
  Value: string;
  Disabled: boolean;
  Selected: boolean;
}

export class Client {
  PartnerId: number;
  PartnerFid: string;
  PartnerAid: string;
  Name: string;
  Contact: string;
  Email: string;
  Phone: string;
  AddressLine1: string;
  AddressLine2: string;
  Zip: number;
  City: string;
  Region: string;
}

export class Sender {
  PartnerId: number;
  PartnerFid: string;
  PartnerAid: string;
  Selection: number;
  Name: string;
  Contact: string;
  Email: string;
  Phone: string;
  AddressLine1: string;
  AddressLine2: string;
  Zip: number;
  City: string;
  Region: string;
  Comment: string;
  Notification: string;
  NotificationText: string;
  PickUpDateText: string;
  PickUpTime: string;
  PickUpTimeText: string;
}

export class Recipient {
  PartnerId: number;
  PartnerFid: string;
  PartnerAid: string;
  Selection: number;
  Name: string;
  Contact: string;
  Email: string;
  Phone: string;
  AddressLine1: string;
  AddressLine2: string;
  Zip: number;
  City: string;
  Region: string;
  Comment: string;
  Notification: string;
  NotificationText: string;
  DeliveryDateText: string;
  DeliveryTime: string;
  DeliveryTimeText: string;
}

export class Address {
  PartnerId: number;
  PartnerAid: string;
  PartnerFid: string;
  PartnerTypeDesc: string;
  GroupDesc: string;
  Description: string;
  DeliveryAddition: string;
  DeliveryStreet: string;
  DeliveryCity: string;
  DeliveryZip: string;
  DeliveryCountry: string;
  DeliveryRegion: string;
  FreightPayer: boolean;
  Phone: string;
  Mobile: string;
  Email: string;
  RevUser: string;
}

export class CityZip {
  ForeignId: string;
  City: string;
  Zip: string;
  Country: string;
}

export class AmagVehicleData {
  Id: number;
  CommissionNumber: string;
  ChassisNumber: string;
  ModelCode: string;
  ModelText: string;
  Color: string;
  Date: Date;
}

/* DamageAdministration */

export class DamageReport {
  DocNum: number;
  CheckDocStateDone: boolean;
  CheckDocStateRelease:	boolean;
  CheckDocStateIncomplete: boolean;
  DamageDate:	string;
  DamageTime: string;
  Insurance: number;
  InsuranceDisplayName: string;
  JobType: number;
  JobTypeDisplayName: string;
  CausedBy: number;
  CausedByDisplayName: string;
  Sender: number;
  SenderDisplayName: string;
  Workshop: number;
  WorkshopDisplayName: string;
  PolicyNo: string;
  Brand: number;
  BrandDisplayName: string;
  Type: number;
  TypeDisplayName: string;
  Identification: string;
  License: string;
  ChassisNo: string;
  Importer: number;
  ImporterDisplayName: string;
  Receiver: number;
  ReceiverDisplayName: string;
  CaseEnd: string;
  CostEstimate: number;
  DamageAmount: number;
  InsuranceAmount: number;
  Reimbursement: string;
  OwnCosts: number;
  InvoiceAmountLow: boolean;
  InvoiceAmountOk: boolean;
  InvoiceAmountHigh: boolean;
  DriverDoor: boolean;
  AnotherDoor: boolean;
  Roof: boolean;
  FrontBumper: boolean;
  RearBumper: boolean;
  FrontFender: boolean;
  RearFender: boolean;
  Bonnet: boolean;
  RearCover: boolean;
  Windshield: boolean;
  RearWindow: boolean;
  SteeringWheel: boolean;
  Rim: boolean;
  Tire: boolean;
  SideMirror: boolean;
  CarSidebar: boolean;
  Headlights: boolean;
  Taillight: boolean;
  Various: boolean;
  Underbody: boolean;
  Comment: string;
  InsuranceComment: string;
  Guilty: boolean;
  UserId: number;
  PrimaryAddressId: number;
  TransitId: number;
  CreatedBy: string;
  LastChangeBy: string;
  InsertType: boolean;
  DamageReportDocuments: DamageReportDocument[];
}

export class DamageReportDocument {
  DamageReportDocumentId: number;
  ReportId: number;
  FileName: string;
  Base64String: string | ArrayBuffer;
  Progress: number;
  Size: number;
  DamageType1: string;
  DamageType2: string;
  DamageComment: string;
}

export class DamageCase {
  Id: number;
  DamageDate:	string;
  DamageTime: string;
  InsuranceId: number;
  JobTypeId: number;
  JobTypeDisplayName: string;
  CausedById: number;
  CausedByDisplayName: string;
  SenderId: number;
  SenderDisplayName: string;
  WorkshopId: number;
  WorkshopDisplayName: string;
  BrandId: number;
  BrandDisplayName: string;
  CarTypeId: number;
  CarTypeDisplayName: string;
  ImporterId: number;
  ImporterDisplayName: string;
  ReceiverId: number;
  ReceiverDisplayName: string;
  Identification: string;
  License: string;
  ChassisNo: string;
  AccountAssignment: string;
  PolicyNo: string;
  CaseEnd: string;
  CostEstimate: number;
  DamageAmount: number;
  InsuranceAmount: number;
  Reimbursement: string;
  OwnCosts: number;
  Comment: string;
  InsuranceComment: string;
  Guilty: boolean;
  UserId: number;
  PrimaryAddressId: number;
  TransitId: number;
  CreatedBy: string;
  LastChangeBy: string;
  ReportedByCustomer: boolean;
  ExternalState: number;
  InternalState: number;
  FeedState: number;
  OriginalSender: string;
  OriginalRecipient: string;
  OriginalModel: string;
  DamageDocuments: DamageDocument[];
  Damages: Damage[];
  Feeds: Feed[];
}

export interface DamageCaseGridVm extends DamageCase {
  ReceiverName?: string;
  WorkshopName?: string;
  JobTypeName?: string;
  BrandName?: string;
  CarTypeName?: string;
  CausedByName?: string;
  InternalStateName?: string;
  InsuranceName?: string;
}

export class DamageDocument {
  Id: number;
  CaseId: number;
  Directory: string;
  DocumentType: string;
  FileName: string;
  Base64: string;
  /* Frontend only */
  TempId?: string;
  InEdit: boolean;
}

export class Damage {
  Id: number;
  CaseId: number;
  AreaId: number;
  TypeId: number;
  Images: DamageImage[];
  AdditionalFotosRequested?: boolean;
  AllowMoreThanFour?: boolean;
  /* Frontend only */
  TempId?: string;
  InEdit: boolean;
}

export class DamageImage {
  Id: number;
  DamageId: number;
  Directory: string;
  FileName: string;
  Base64: string;
}

export class DamageArea {
  Id: number;
  Code: number;
  DescriptionDE: string;
  DescriptionEN: string;
  DescriptionFR: string;
  DescriptionIT: string;
}

export class DamageType {
  Id: number;
  Code: number;
  DescriptionDE: string;
  DescriptionEN: string;
  DescriptionFR: string;
  DescriptionIT: string;
}

export class Feed {
  Id: number;
  CaseId: number;
  SenderName: string;
  ExternalSender: boolean;
  ContentHtml: string;
  TimeStamp: Date;
}

export class Employee {
  UniqueId: number;
  FirstName: string;
  LastName: string;
  UserName: string;
  IsActive: boolean;
  IsWebUser: boolean;
  IsAdministrator: boolean;
  Password: string;
}

export class CarBrand {
  CarBrandId: number;
  CarBrandName: string;
  ImporterId: number;
  ImporterName: string;
}

export class CarType {
  CarTypeId: number;
  CarTypeName: string;
  CarBrandId: number;
  CarBrandName: string;
}

export class Importer {
  ImporterId: number;
  ImporterName: string;
  ImporterTransitId: string;
}

export class Insurance {
  InsuranceId: number;
  InsuranceName: string;
  PoliceNo: string;
}

export class JobType {
  JobTypeId: number;
  JobTypeName: string;
  SqlSelect: string;
}

export class Receiver {
  ReceiverId: number;
  ReceiverName: string;
  // tslint:disable-next-line:variable-name
  Receiver_Id_Transit: string;
}

export class Log {
  LogId: number;
  LogMessage: string;
  LoggedByUser: string;
  DocNum: string;
  ModifyDate: string;
}

export class Evaluation {
  UniqueId: number;
  CausedBy: string;
  CustomerType: string;
  CausedByUserName: string;
  CountOfDamages: number;
  DamageAmountSum: number;
  QuantityCarTransport: number;
  Quote: number;
  DamageDetails: DamageDetails[];
}

export class DamageDetails {
  UniqueId: number;
  CarBrandName: string;
  CarTypeName: string;
  ChassisNo: string;
  DamageAmount: number;
  DamageDate: string;
  DocNum: number;
  Identification: string;
  ReceiverName: string;
}

export class SmartLabelsChartData {
  xValue: string;
  yValue: number;
  text: string;
  sumOfDamageAmount: number;
}

export class VehicleData {
  Vin: string;
  Model: string;
}

export interface MotrackingResponse {
  Lat: number;
  Lng: number;
}

export interface TrackingModel {
  DateOfDelivery: Date;
  IsDelivered: boolean;
}

export class RegistrationData {
  FirstName: string;
  LastName: string;
  Company: string;
  Additive: string;
  StreetAndNumber: string;
  Zip: string;
  City: string;
  Phone: string;
  Email: string;
  Language: string;
  Password: string;
}

export class LogisticsOrder {
  customerReference: string;
  orderingAccountId: string;
  primaryInvoiceRecipientId: string;
  orderSource: string;
  processId: string;
  orderType: string;
  vin: string;
  make: string;
  model: string;
  // Frontend only
  index: number;
  status: number;
  message: string;
  orderNumber: string|null;
}

export class LogisticsOrderRequest {
  customerReference: string;
  orderingAccount: {
    id: string
  };
  primaryInvoiceRecipient: {
    id: string
  };
  orderSource: string;
  processId: string;
  orderType: string;
  vehicle: {
    vin: string;
    make: string;
    model: string;
  };
}

export class LogisticsOrderResponse {
  status: string;
  orderNumber: string;
  details: string;
}
